import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import GlobalIP from "../../components/Admin/GlobalIP"

const GlobaliP = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Global IP's | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <GlobalIP />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default GlobaliP
